var React = require('react');

function Cloud (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M69.9997 76H35.9997C30.8071 75.9987 25.7172 74.5535 21.2988 71.8259C16.8803 69.0983 13.3073 65.1958 10.9791 60.5545C8.65095 55.9131 7.65924 50.7158 8.11483 45.5433C8.57043 40.3708 10.4554 35.4268 13.5591 31.2639C16.6627 27.101 20.8628 23.8832 25.6901 21.9699C30.5173 20.0567 35.7814 19.5235 40.8943 20.4299C46.0071 21.3362 50.7672 23.6465 54.6426 27.1024C58.518 30.5584 61.3561 35.0239 62.8397 40H69.9997C74.7736 40 79.3519 41.8964 82.7276 45.2721C86.1032 48.6477 87.9997 53.2261 87.9997 58C87.9997 62.7739 86.1032 67.3523 82.7276 70.7279C79.3519 74.1036 74.7736 76 69.9997 76Z","stroke":"black","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Cloud.defaultProps = {"width":"96","height":"96","viewBox":"0 0 96 96","fill":"none"};

module.exports = Cloud;

Cloud.default = Cloud;
